export default __webpack_public_path__ + "static/media/background-audio.b5103114.mp3";